var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.903,
    height: 11.903,
    viewBox: "0 0 11.903 11.903",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "close",
    d: "M10.913.624,10.29,0,5.457,4.833.624,0,0,.624,4.833,5.457,0,10.29l.624.624L5.457,6.08l4.833,4.833.624-.624L6.08,5.457Z",
    transform: "translate(0.495 0.495)",
    fill: "#2e384d",
    stroke: "#2e384d",
    strokeWidth: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.10651ce88d8f199e8124f4db30e2fe05.svg";
export { ForwardRef as ReactComponent };